import React from "react";
import AdnDropdown from "../adnDropdown/AdnDropdown";
import { Months } from "../GeneralConfigurations";
import { Col, Row } from "antd";
import { useTranslation } from "react-i18next";

const AdnMonthYearDropdown = ({
  handleMonthChange,
  handleYearChange,
  monthLabel = "",
  yearLabel = "",
  allowMonthClear = false,
  allowYearClear = false,
  defaultMonthValue,
  defaultYearValue = new Date().getFullYear(),
  initialYear = 2016,
  disabledMonth = false,
  disabledYear = false,
}) => {
  const { t } = useTranslation();

  // Mapear meses para tradução
  const monthMapping = {
    1: "january",
    2: "february",
    3: "march",
    4: "april",
    5: "may",
    6: "june",
    7: "july",
    8: "august",
    9: "september",
    10: "october",
    11: "november",
    12: "december",
  };

  const months = Object.entries(Months).map((m) => ({
    id: m[0],
    name: t(`common.months.${monthMapping[m[0]]}`),
  }));

  const currentMonth = new Date().getMonth() + 1;
  const defaultMonth = defaultMonthValue 
    ? (typeof defaultMonthValue === 'number' ? String(defaultMonthValue) : defaultMonthValue)
    : String(currentMonth);
  const yearArray = [];
  for (let year = initialYear; year <= new Date().getFullYear() + 1; year++) {
    yearArray.push(year);
  }
  const years = Object.entries(yearArray).map((year) => ({
    id: year[1],
    name: year[1],
  }));

  return (
    <Row gutter={16} style={{ width: "100%", margin: "0" }}>
      <Col span={12} style={{ paddingLeft: "0" }} className="filter-item">
        <AdnDropdown
          label={monthLabel}
          placeholder={t("common.month")}
          allowClear={allowMonthClear}
          defaultValue={defaultMonth}
          options={months}
          handleChange={handleMonthChange}
          disabled={disabledMonth}
        />
      </Col>
      <Col span={12} style={{ paddingRight: "0" }} className="filter-item">
        <AdnDropdown
          label={yearLabel}
          placeholder={t("common.year")}
          allowClear={allowYearClear}
          defaultValue={defaultYearValue}
          options={years}
          handleChange={handleYearChange}
          disabled={disabledYear}
        />
      </Col>
    </Row>
  );
};

export default AdnMonthYearDropdown;
